"use client";
import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { type ILink, type IPagePath } from "@contentful-api/types/contentful";
import { Button, type ButtonProps } from "@ui/components/forms/button/Button";

interface ButtonLinkModalProps extends ButtonProps {
    link: ILink | IPagePath;
}

export function ButtonLinkModal({ link, onClick, ...rest }: ButtonLinkModalProps) {
    const { showModal } = useGlobalModalContext();
    const { modal, label, description, descriptionRichText } = (link as ILink).fields;

    function handleClick(e: React.MouseEvent<HTMLButtonElement>) {
        onClick?.(e);
        if (e.defaultPrevented) return;
        showModal(modal ?? "base", { description, label, descriptionRichText });
    }

    return (
        <Button {...rest} onClick={handleClick} aria-haspopup={!!modal ? "dialog" : undefined}>
            {label}
        </Button>
    );
}
